import { SessionQualification } from '../../enums/session-qualification';

/** Values shown in the sessions table “Status” column (filters must match). */
export const SessionTableStatus = {
  IN_PROGRESS: 'in_progress',
  COMPLETED_SUCCESSFULLY: 'completed_successfully',
  COMPLETED: 'completed',
} as const;

export type SessionTableStatus =
  (typeof SessionTableStatus)[keyof typeof SessionTableStatus];

export const SESSION_TABLE_STATUS_VALUES = Object.values(
  SessionTableStatus,
) as SessionTableStatus[];

/** Values shown in the “Anomaly Detected” column (filters must match). */
export const ANOMALY_SESSION_QUALIFICATION_VALUES = [
  SessionQualification.FAILED,
  SessionQualification.ABORTED,
  SessionQualification.NOT_CLOSED,
  SessionQualification.REFUSED_AT_START,
] as const;

export type AnomalySessionQualification =
  (typeof ANOMALY_SESSION_QUALIFICATION_VALUES)[number];

export function sessionTableStatusLabelKey(status: SessionTableStatus): string {
  switch (status) {
    case SessionTableStatus.IN_PROGRESS:
      return 'stillCharging';
    case SessionTableStatus.COMPLETED_SUCCESSFULLY:
      return 'completedSuccessfully';
    case SessionTableStatus.COMPLETED:
      return 'completed';
    default:
      return 'completed';
  }
}
